import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import styles from './styles.module.css';

const UCLicenseMsg = () => (
  <div className={`${styles.component} animate__animated animate__fadeIn`}>
    <Paper elevation={1}>
      <Typography component="p">
        UCLicenseMsg
      </Typography>
    </Paper>
  </div>
);

export default UCLicenseMsg;
